import { Component, OnInit } from '@angular/core';
import { MemberQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';
import { TierLevels } from 'src/app/shared/utilities/tier-levels';

@Component({
  selector: 'fgb-earn-page',
  templateUrl: './earn-page.component.html',
  styleUrls: ['./earn-page.component.scss'],
})
export class EarnPageComponent implements OnInit {
  populations = Populations;
  tierLevel = TierLevels;
  tierName: string = '';

  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.tierName = this.memberQuery.getUserContext().tierName;
  }

  checkEligible(tier: string): boolean {
    if (this.tierName === this.tierLevel.Legend) {
      return true;
    } else if (tier === this.tierLevel.Mvp) {
      if ([this.tierLevel.Legend, this.tierLevel.Mvp].includes(this.tierName)) {
        return true;
      }
    } else if (tier === this.tierLevel.AllStar) {
      if ([this.tierLevel.Legend, this.tierLevel.Mvp, this.tierLevel.AllStar].includes(this.tierName)) {
        return true;
      }
    }
    return false;
  }
}
